import React from 'react'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardActions from '@material-ui/core/CardActions'
import Avatar from '@material-ui/core/Avatar'
import { Button } from '@material-ui/core'
import { CancelButton } from '../../Buttons'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import { useCardStyles } from './styles'

const PlanCard = (): JSX.Element => {
  const classes = useCardStyles()

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            <StarBorderIcon />
          </Avatar>
        }
        action={
          <span>
            R$ XXX,XX<small>/mês</small>
          </span>
        }
        title="Plano Simples"
        subheader="1 Acesso, 20 lentes"
      />
      <CardActions className={classes.actions}>
        <Button color="primary" variant="contained">
          Atualizar Plano
        </Button>
        <CancelButton variant="contained">Cancelar Plano</CancelButton>
      </CardActions>
    </Card>
  )
}

export default PlanCard
